import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetWatermarkDetailQuery} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {WatermarkForm} from './WatermarkForm';

export function PhotosWatermarkingDetail() {
  const {id} = useParams();
  const {data, isLoading, isError} = useGetWatermarkDetailQuery(
    {watermarkId: id ?? ''},
    {skip: isNilOrEmpty(id)}
  );

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          isNil(id)
            ? i18n.t('page.salesSettings.labels.watermarks.newConfiguration')
            : i18n.t('page.salesSettings.labels.watermarks.configuration', {name: data?.name}),
          i18n.t('page.salesSettings.labels.watermarks.name'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        isLoading={isLoading}
        // A failed load must not fall back to an empty form, which would save as a new watermark.
        isError={isError}
        header={{
          title: data?.name
            ? i18n.t('page.salesSettings.labels.watermarks.configuration', {name: data?.name})
            : i18n.t('page.salesSettings.labels.watermarks.newConfiguration'),
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
            {
              label: i18n.t('page.salesSettings.labels.watermarks.name'),
              href: settingsRoutes.advertisingWatermarking,
            },
          ],
        }}
        description={i18n.t('page.salesSettings.labels.watermarks.formDescription')}
        data-testid="settings-advertising-watermarking-detail"
      >
        <WatermarkForm watermarkId={id} watermark={data} />
      </SettingsTemplate>
    </>
  );
}
